export default "8ec2b4ec0b85c78e30efc69c0a111da1.svg";